import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

class FooterButtons extends Component {
  static propTypes = {
    resetUpload: PropTypes.func,
    saveFiles: PropTypes.func
  };

  render() {
    const { resetUpload, saveFiles } = this.props;
    return (
      <div className="footerUpload">
        <Button
          kind="secondary"
          colorScheme={"ghost"}
          onClick={resetUpload.bind(this)}
          style={{ margin: "16px" }}
        >
          <FormattedMessage id="actions.cancel" />
        </Button>
        <Button className={"gs-upload-confirm"} onClick={saveFiles.bind(this)} style={{ margin: "16px" }}>
          <FormattedMessage id="upload.confirm" />
        </Button>
      </div>
    );
  }
}

export default FooterButtons;
